/**
 * Payload Normalizer — normaliza e valida o payload antes do insert.
 *
 * Garantias:
 *  - Exatamente UM anchor (PPU | EAP | UBS)
 *  - Strings vazias viram null (defesa contra CHECK polimórfico)
 *  - os_id obrigatório quando modo = UBS
 */

import { detectMode, type ExecucaoMode } from './anchorResolver';

const ANCHORS = ['planilha_item_id', 'os_item_id', 'cronograma_atividade_id'] as const;

export function normalizeExecucaoPayload<T extends Record<string, any>>(payload: T): T {
  const out: any = { ...payload };
  for (const k of ANCHORS) {
    if (out[k] === '' || out[k] === undefined) out[k] = null;
  }
  if (out.os_id === '' || out.os_id === undefined) out.os_id = null;
  return out;
}

export function assertExactlyOneAnchor(payload: Record<string, any>): ExecucaoMode {
  const present = ANCHORS.filter((k) => payload[k] != null && payload[k] !== '');
  if (present.length === 0) {
    throw new Error(
      '[execucao] payload inválido: nenhum anchor presente (esperado planilha_item_id | os_item_id | cronograma_atividade_id).',
    );
  }
  if (present.length > 1) {
    throw new Error(
      `[execucao] payload inválido: múltiplos anchors presentes (${present.join(', ')}). Use exatamente um.`,
    );
  }
  const mode = detectMode(payload);
  if (!mode) throw new Error('[execucao] payload inválido: anchor irreconhecível.');
  if (mode === 'ubs' && !payload.os_id) {
    throw new Error('[execucao] payload UBS exige os_id (CHECK emp_ve_ubs_os_id_check).');
  }
  return mode;
}
